const { OKTA_CLIENT_ID, OKTA_ISSUER } = process.env

export default {
  oidc: {
    clientId: OKTA_CLIENT_ID,
    issuer: OKTA_ISSUER,
    redirectUri: window.location.origin + '/login/callback',
    scopes: ['openid', 'profile']
  },
  resourceServer: {
    messagesUrl: ''
  }
}
